import About from './AboutPage';
import Hero from '../components/Hero';
import { junfelArt, junfelMessage } from '../utils/consoleMessage';
import Certificates from '../components/Certificates';
import MoreInfo from '../components/MoreInfo';
import Footer from '../components/Footer';
import Portfolio from '../components/Portfolio';
import TechStack from '../components/TechStack';
import ProjectsWeb from '../components/ProjectsWeb';

const Home = () => {
	// console.log("%c" + junfelArt, "color: #888888; font-family: monospace;");	
	// console.log(junfelMessage);
	
	return (
		<>
			<Hero />
			<About />
			{/* <Portfolio /> */}
			<TechStack />
			<Certificates />
			<ProjectsWeb />
			{/* <MoreInfo /> */}
			<Footer />
		</>
	);
};

export default Home;
